import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SecurityContext, inject } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { fadeInAnimation } from '../../animation';
import { WidthHeightDirective } from '../../widthHeightDirective';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CommonModule, DecimalPipe } from '@angular/common';
import { Api } from '../../services/api';
import { LoaderService } from '../../services/loader';
import { Toaster } from '../../services/toaster';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-audit-log-risk-officer',
  // imports: [CommonModule, TooltipModule, WidthHeightDirective, TableModule, ButtonModule],
  imports: [CommonModule, TooltipModule, TableModule, ButtonModule, WidthHeightDirective],
  templateUrl: './audit-log-risk-officer.html',
  styleUrl: './audit-log-risk-officer.scss',
  animations: [fadeInAnimation],
  providers: [DecimalPipe]
})
export class AuditLogRiskOfficer implements OnInit, AfterViewInit {
  @Input() issueIds: string = '';
  @Input() pflmId: number = 0;
  @Input() statusData: any[] = [];
  @Input() reasonsData: any[] = [];
  @Input() impactAreaData: any[] = [];
  @Input() severityData: any[] = [];
  @Output() dataLoaded = new EventEmitter<void>();
  auditLogs: any[] = [];
  // pflmId = 9538;
  auditLogsGroupedByIssueID: any[] = [];
  expandedRows: { [key: number]: boolean } = {};
  showContent = false;
    private sanitizer = inject(DomSanitizer);

  constructor(
    public cd: ChangeDetectorRef,
    private decimalPipe: DecimalPipe,
    private apiService: Api,
    private loaderService: LoaderService,
    private toasterService: Toaster
  ) { }

  ngOnInit() {
    // this.fetchAuditLogs();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.fetchAuditLogs();
    });
  }

  // groupByIssueIdToArray(auditLogs: any[]): any[] {
  //   const grouped = auditLogs.reduce((acc, log) => {
  //     const issueId = log.IssueId;
  //     if (!acc[issueId]) {
  //       acc[issueId] = {
  //         issueId: issueId,
  //         issueName: log.IssueName,
  //         issueDescription: log.IssueDescription,
  //         audits: []
  //       };
  //     }
  //     acc[issueId].audits.push(log);
  //     return acc;
  //   }, {} as { [key: number]: any });

  //   return Object.values(grouped);
  // }

  groupByIssueIdToArray(auditLogs: any[]): any[] {
    const grouped = auditLogs.reduce((acc, log) => {
      const issueId = log.issue_id;

      if (!acc[issueId]) {
        acc[issueId] = {
          issue_id: issueId,
          issue_name: this.sanitizeHtml(log.issue_name),
          issue_description: this.sanitizeHtml(log.issue_description),
          audits: []
        };
      }

      acc[issueId].audits.push(log);
      return acc;
    }, {});

    return Object.values(grouped);
  }

  onRowExpand(event: any) {
    const issueId = event.data.issue_id;
    if (issueId !== undefined) {
      this.expandedRows = {
        ...this.expandedRows,
        [issueId]: true
      };
    }
  }

  onRowCollapse(event: any) {
    const issueId = event.data.issue_id;
    if (issueId !== undefined) {
      const { [issueId]: _, ...rest } = this.expandedRows;
      this.expandedRows = rest;
    }
  }

  closeAuditLog() {
    this.auditLogs = [];
    this.auditLogsGroupedByIssueID = [];
    this.expandedRows = {};
    this.showContent = false;
    this.cd.detectChanges();
    // Notify the parent so *ngIf destroys this component — ensures next open is a fresh load
    this.apiService.showAuditLog$.next(false);
    this.apiService.auditLogIssueIds$.next('');
    this.apiService.auditLogPflmId$.next(0);
  }

  formatNumbersInString(value: any): string {
    const formatIfNeeded = (match: string, dollar: string, rawNumber: string) => {
      const numeric = rawNumber.replace(/,/g, '');
      const parsed = Number(numeric);

      if (isNaN(parsed)) return match;

      // Detect original decimal precision
      const hasDecimal = rawNumber.includes('.');
      const decimalPlaces = hasDecimal ? (rawNumber.split('.')[1]?.length || 0) : 0;

      const format = `1.${decimalPlaces}-${decimalPlaces}`;
      const formatted = parsed >= 1000
        ? this.decimalPipe.transform(parsed, format)
        : parsed.toString();

      return (dollar ?? '') + (formatted ?? match);
    };

    if (typeof value === 'number' || this.apiService.isNumeric(value)) {
      const valueStr = value.toString();
      const hasDecimal = valueStr.includes('.');
      const decimalPlaces = hasDecimal ? (valueStr.split('.')[1]?.length || 0) : 0;
      const format = `1.${decimalPlaces}-${decimalPlaces}`;

      return Number(value) >= 1000
        ? this.decimalPipe.transform(Number(value), format) ?? valueStr
        : valueStr;
    }

    if (typeof value === 'string') {
      return value.replace(/\b(\$)?([\d,]+(?:\.\d+)?)\b/g, formatIfNeeded);
    }

    return String(value ?? '');
  }

  resolveDisplayValue(fieldName: string, value: string): string {
    if (value == null) return '';
    const trimmedValue = String(value).trim();
    if (trimmedValue === '') return '';
    const numericId = Number(trimmedValue);
    if (isNaN(numericId)) return trimmedValue; // already text, no lookup needed

    const fn = (fieldName || '').trim().toLowerCase();

    if (fn === 'issue status') {
      const match = this.statusData.find((s: any) => Number(s.issue_status_id) === numericId);
      return match ? match.issue_description : value;
    }
    if (fn === 'reason') {
      const match = this.reasonsData.find((r: any) => Number(r.id) === numericId);
      return match ? match.reason : value;
    }
    if (fn === 'risk severity' || fn === 'severity_id') {
      const match = this.severityData.find((s: any) => Number(s.severity_id) === numericId);
      return match ? match.severity : value;
    }
    if (fn === 'impact area') {
      const match = this.impactAreaData.find((i: any) => Number(i.impact_id) === numericId);
      return match ? match.impact : value;
    }

    return value;
  }

  formatAuditDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);

    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 becomes 12

    const hh = String(hours).padStart(2, '0');
    return `${mm}/${dd}/${yyyy} ${hh}:${minutes}:${seconds} ${ampm}`;
  }

  fetchAuditLogs(): void {
    this.loaderService.show();
    const ids = (this.issueIds || '')
      .split(',')
      .map(id => Number(id.trim()))
      .filter(n => !isNaN(n));

    const payload = { IssueIds: ids, PFLMId: this.pflmId };

    if (!this.issueIds.length) {
      console.warn('[AuditLog] No issue IDs to fetch audit logs for.');
      return;
    }

    this.apiService.fetchAuditLogsAPI(payload).subscribe({
      next: (res: any) => {
        this.loaderService.hide();
        this.auditLogs = Array.isArray(res?.logs) ? res.logs : [];
        this.auditLogs.forEach(log => {
          log.field_name = this.sanitizeHtml(log.field_name);
          log.previous_value = this.sanitizeHtml(log.previous_value);
          log.updated_value = this.sanitizeHtml(log.updated_value);
        });
        this.auditLogs = this.auditLogs.map(a => ({
          ...a,
          // PrimeNG sorting REQUIRES a matching field name.
          UpdatedDate: a.updated_date
        }));
        this.auditLogsGroupedByIssueID = this.groupByIssueIdToArray(this.auditLogs);

        // Only show when there is data
        this.showContent = this.auditLogs.length > 0;
        this.dataLoaded.emit();

        // Ensure change detection runs in case this is inside an overlay/sheet
        this.cd.detectChanges();

      },
      error: (err) => {
        this.loaderService.hide();
        console.error('[AuditLog] Fetch failed →', err);
        this.toasterService.setError({
          message: 'Unable to fetch the data.',
          type: 'error',
        });
      }
    });
  }

    private sanitizeHtml(html: string): string {
    const decoded = this.decodeHtml(html);
    const div = document.createElement('div');
    div.innerHTML = this.sanitizer.sanitize(
      SecurityContext.HTML,
      decoded
    ) || '';
    return div.textContent || '';
  }

  private decodeHtml(encodedHtml: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = encodedHtml;
    return textarea.value;
  }

}



